import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DetailItem, OfferCardData, OfferCardDataDriver, OfferCardType } from '../offer-card-data.model';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { LoyaltyMode } from '@shopping-angular-components/loyalty';

declare var window: any;

@Component({
  selector: 'offer-card-detail-info',
  template: `
    <div>

      <outstanding-driver *ngIf="data.mealplans_driver" [outstandingDriverData]="data.mealplans_driver" [isTopPosition]="true"></outstanding-driver>

      <outstanding-driver *ngIf="this.data.outstanding_driver" [outstandingDriverData]="this.data.outstanding_driver"></outstanding-driver>

      <div class="offer-card-title small-title" *ngIf="data.main_text">{{data.main_text}}</div>

      <div class="offer-dates-container" *ngIf="(data.dates?.from?.text || data.dates?.to?.text) && offerCardType !== 'REDUCED'">
          <span class="offer-date-wrapper" *ngIf="data.dates.from?.text">
            <span>{{'offers.dates.from' | translate}}</span>
            <em class="offer-date -eva-3-bold -eva-3-capitalize -eva-3-pr-sm">{{data.dates.from!.text}}</em>
          </span>

        <span class="offer-date-wrapper" *ngIf="data.dates.to?.text">
            <span>{{'offers.dates.to' | translate}}</span>
            <em class="offer-date -eva-3-bold -eva-3-capitalize">{{data.dates.to!.text}}</em>
          </span>
      </div>

      <div class="offer-card-auxiliary-container" *ngIf="data.auxiliary_text && offerCardType === 'REDUCED'">
        <i class="eva-3-icon-{{auxiliaryIconClassName}} -eva-3-icon-xsm"></i>
        <div class="offer-card-auxiliary-text-container eva-3-p -eva-3-ellipsis">
          {{data.auxiliary_text}}
        </div>
      </div>

      <div *ngIf="showSmallText" class="offer-small-text">{{data.small_text}}</div>

      <div class="offer-card-items-container">
        <flight-item *ngIf="hasFlight()" [data]="data.detail_items['FLIGHT']" [locale]="locale" [flow]="flow" [offerCardType]="offerCardType"></flight-item>
        <hotel-item *ngIf="hasHotel()" [data]="data.detail_items['HOTEL']" [offerCardType]="offerCardType"></hotel-item>
        <tour-item *ngIf="hasTour()" [data]="data.detail_items['TOUR'] || data.detail_items['TICKET']"></tour-item>
      </div>
    </div>
  `,
  styleUrls: ['./offer-card-detail-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OfferCardDetailInfoComponent implements OnInit {

  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() positionIndex: number;

  @Input() data: OfferCardData;
  @Input() locale: string;
  @Input() flow: string;
  @Input() product: string;
  @Input() offerCardType: OfferCardType;

  @Input() loyaltyMode: LoyaltyMode | null;

  paymentsMediaKey?: string;
  auxiliaryIconClassName: string
  showSmallText = false;
  iconClassMap = {
    hotels: 'location',
    vacation_rentals: 'location',
    assistances: 'calendar',
    default: 'departure'
  };

  constructor(private mediaPictureService: MediaPictureService) {
  }

  ngOnInit(): void {
    this.paymentsMediaKey = this.mediaPictureService.getMediaUrl(this.data.payments_media_key);
    this.data.detail_items = this.data.detail_items || {}
    this.auxiliaryIconClassName = this.iconClassMap[this.data.product] || this.iconClassMap.default;
    this.showSmallText = (this.data.product === 'tickets' && this.offerCardType === 'REDUCED' || this.data.product === 'traslate') && !!this.data.small_text;
  }

  hasFlight(): boolean {
    return this.data.detail_items.FLIGHT != null;
  }

  hasHotel(): boolean {
    return this.data.detail_items.HOTEL != null;
  }

  hasTour(): boolean {
    return this.data.detail_items.TOUR != null || this.data.detail_items.TICKET != null;
  }

}

@Component({
  selector: 'flight-item',
  template: `
    <span class="flight-item item">
      <i class="eva-3-icon-flights icon -eva-3-icon-xsm"></i>
      <span *ngIf="offerCardType === 'REDUCED' && (data.auxiliary_text || data.text)" class="eva-3-caption -eva-3-pl-xsm -eva-3-pr-xsm">
        {{data.auxiliary_text || data.text}}
      </span>
      <span *ngIf="offerCardType !== 'REDUCED'" class="flight-content-container">
        <span class="flight-content-row first">
          <em>{{data.text}}</em>

          <span class="codes-wrapper">
            <em class="code-departure">{{data.from}}</em>
            <em class="icon-arrows -eva-3-pl-xsm">
              <i class="arrow-right eva-3-icon-arrow-bold-right"></i>
              <i class="arrow-left eva-3-icon-arrow-bold-left"></i>
            </em>
            <em class="code-return -eva-3-pl-xsm -eva-3-pr-xsm">{{data.to}}</em>
          </span>
        </span>
        <span class="flight-content-row second">
          <baggages-wrapper [baggageInfo]="data.baggage_info" [locale]="locale" [flow]="flow"></baggages-wrapper>
          <img *ngIf="data.airline_code" [src]="getAirlineImg()" loading="lazy" alt="airline"/>
        </span>
      </span>
    </span>
  `,
  styleUrls: ['./offer-card-detail-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FlightItemComponent {
  @Input() data: DetailItem;
  @Input() locale: string;
  @Input() flow: string;
  @Input() offerCardType: OfferCardType;

  getAirlineImg() {
    const country = this.locale.replace('-', '_').split('_')[1]?.toLowerCase() || 'www'; 
    const imgUrl = `//${country}.staticontent.com/shop/flights-busquets/api/v1/web/flights-logos/airline/${this.data.airline_code}`;
    return this.data.airline_code ? imgUrl : null;
  }
}

@Component({
  selector: 'hotel-item',
  template: `
    <span class="hotel-item item">
      <i class="{{this.icon}} icon -eva-3-icon-xsm"></i>
      <div *ngIf="offerCardType === 'REDUCED'">
        <span *ngIf="this.stars.length !== 0" class="offer-card-rating-stars stars-wrapper -eva-3-pr-sm">
          <i *ngFor="let star of stars" class="-eva-3-icon-xsm eva-3-icon-star-filled"></i>
        </span>
        <em *ngIf="this.stars.length === 0" class="text hotel-name">{{data.text}}</em>
      </div>
      <span *ngIf="offerCardType !== 'REDUCED'"  class="hotel-content-container">
        <span class="hotel-content-row first">
          <em class="text hotel-name">{{data.text}}</em>
          <span class="-eva-3-pl-sm -eva-3-pr-xsm" *ngIf="data.overall_rating">
            <review-score [score]="data.overall_rating"></review-score>
          </span>
        </span>
        <span class="hotel-content-row second">
          <span *ngIf="data.stars" class="offer-card-rating-stars stars-wrapper -eva-3-pr-sm">
            <i *ngFor="let star of stars" class="-eva-3-icon-xsm eva-3-icon-star-filled"></i>
          </span>
          <em class="regime-text -eva-3-tc-green-3">{{data.regime}}</em>
        </span>
      </span>
    </span>
  `,
  styleUrls: ['./offer-card-detail-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HotelItemComponent implements OnInit {
  @Input() data: DetailItem;
  @Input() offerCardType: OfferCardType;

  stars: Array<any>;
  icon: string;

  constructor() {
    this.stars = [];
  }

  ngOnInit() {
    this.initIcon();
    this.initStars();
  }

  private initStars(): void {
    if (this.data.stars) {
      this.stars = new Array(Number(this.data.stars)).fill({});
    }
  }

  private initIcon(): string {
    return this.icon = this.data.type !== "HOTEL" ? 'eva-3-icon-rentals' : 'eva-3-icon-hotels'
  }
}

@Component({
  selector: 'tour-item',
  template: `
    <span class="activity-item item">
      <i class="eva-3-icon-tickets icon -eva-3-icon-xs"></i>
      <span class="activity-text">
        <em class="text -eva-3-capitalize">{{ labelText | translate}}</em>
        <em class="label -eva-3-bold -eva-3-ml-xsm">{{data.text}}</em>
      </span>
    </span>
  `,
  styleUrls: ['./offer-card-detail-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TourItemComponent implements OnInit {
  @Input() data: DetailItem;

  labelText: string;

  ngOnInit() {
    this.labelText = 'offers.items.' + (this.data.text.split(',').length > 1 ? 'activities' : 'activity');
  }
}

